<div class="page-shell">
    <div class="hero-card">
    <div>
        <div class="eyebrow">
        <span class="dot"></span>
        Toyota Product Management Tool
        </div>
        <h1>Version Explorer</h1>
    </div>

    <div class="stats-grid">
        <div class="stat-card">
        <span>Active version</span>
        <strong>{{ selectedVersion.label }}</strong>
        </div>
        <div class="stat-card">
        <span>Linked tickets</span>
        <strong>{{ selectedVersion.tickets.length }}</strong>
        </div>
        <div class="stat-card">
        <span>Evidence items</span>
        <strong>{{ selectedVersion.evidence.length }}</strong>
        </div>
        <div class="stat-card">
        <span>Owner</span>
        <strong>{{ selectedVersion.author }}</strong>
        </div>
        <div class="stat-card">
        <span>Created Date</span>
        <strong>{{ selectedVersion.date }}</strong>
        </div>
    </div>
    </div>

    <div class="main-grid">
    <aside class="sidebar-card">
        <div class="section-title">
        <h2>Versions</h2>
        <p>Explore releases in chronological order.</p>
        </div>

        <div class="version-list">
        @for (version of versions; track version.id; let i = $index) {
            <button
            class="version-item"
            [class.active]="selectedVersion.id === version.id"
            (click)="selectVersion(version.id)"
            >
            <div class="version-row">
                <div class="version-meta">
                <div class="version-heading">
                    <span class="version-dot" [style.background]="version.color"></span>
                    <strong>Version {{ version.label }}</strong>
                    @if (i === 0) {
                    <span class="badge latest">Latest</span>
                    }
                </div>
                <div class="version-date">{{ version.date }}</div>
                <p>{{ version.summary }}</p>
                </div>
                <span class="chevron">›</span>
            </div>
            </button>
        } @empty {
            <div class="empty-state">No versions available for the selected use case.</div>
        }
        </div>
    </aside>

    <section class="content-column">
        <article class="content-card">
        <div class="content-header">
            <div>
            <div class="badge-row">
                <span class="badge outline">Toyota Connected App</span>
                <span class="status-pill"
                    [style.backgroundColor]="selectedVersion.color || '#94a3b8'"
                    [style.borderColor]="selectedVersion.color || '#94a3b8'"
                    [style.color]="'#ffffff'">
                {{ selectedVersion.status }}
                </span>
            </div>
            <h2>Version {{ selectedVersion.label }}</h2>
            <p class="subtle">{{ selectedVersion.summary }}</p>
            </div>

            <div class="owner-card">
            <div class="avatar">{{ initials(selectedVersion.author) }}</div>
            <div>
                <strong>{{ selectedVersion.author }}</strong>
                <span>Release owner</span>
            </div>
            </div>
        </div>

        <div class="tabbar">
            <button [class.active]="activeTab === 'changes'" (click)="activeTab = 'changes'">Changes</button>
            <button [class.active]="activeTab === 'tickets'" (click)="activeTab = 'tickets'">Tickets</button>
            <button [class.active]="activeTab === 'evidence'" (click)="activeTab = 'evidence'">Evidence</button>
        </div>

        @if (loadingVersions) {
            <div class="empty-state">Loading versions...</div>
        }

        @if (loadError) {
            <div class="error-state">{{ loadError }}</div>
        }

        @if (!loadingVersions && !loadError && activeTab === 'changes') {
            <div class="tab-content">
            <div class="split-grid">
                <div class="panel change-panel">
                <h3>Change summary</h3>
                @if (selectedVersion.changeHistoryHtml?.trim()) {
                <div class="change-list">
                    <div class="change-history-html" [innerHTML]="selectedVersion.changeHistoryHtml"></div>
                </div>
                }
                </div>

                <div class="detail-card">
                    <h3>Metrics</h3>
                    <div class="metrics-grid">
                    <div class="metric">
                        <div class="metric-value">{{ selectedVersion.tickets.length }}</div>
                        <div class="metric-label">Tickets</div>
                    </div>
                    <div class="metric">
                        <div class="metric-value">{{ selectedVersion.changes.length }}</div>
                        <div class="metric-label">Changes</div>
                    </div>
                    <div class="metric">
                        <div class="metric-value">{{ selectedVersion.evidence.length }}</div>
                        <div class="metric-label">Evidence</div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        }

        @if (!loadingVersions && !loadError && activeTab === 'tickets') {
            <div class="tab-content">
            <div class="ticket-list">
                @for (ticket of selectedVersion.tickets; track ticket.key) {
                <div
                    class="ticket-card ticket-card-link"
                    role="button"
                    tabindex="0"
                    (click)="openTicket(ticket)"
                    (keydown.enter)="openTicket(ticket)"
                    (keydown.space)="openTicket(ticket); $event.preventDefault()"
                >
                    <div class="ticket-topline">
                    <div class="ticket-tags">
                        <span class="badge secondary">{{ ticket.key }}</span>
                        <span class="badge outline">{{ ticket.type }}</span>
                        <span class="badge done">{{ ticket.status }}</span>
                    </div>
                    </div>
                    <div class="ticket-title">{{ ticket.title }}</div>
                    <div class="ticket-subtle">Linked directly to version {{ selectedVersion.label }}</div>
                    <div class="ticket-subtle">Open ticket details</div>
                </div>
                }
            </div>
            </div>
        }

        @if (!loadingVersions && !loadError && activeTab === 'evidence') {
            <div class="tab-content">
            <div class="evidence-grid">
                @for (item of selectedVersion.evidence; track item.title) {
                <div class="evidence-card">
                    <div class="evidence-preview">
                    <div class="evidence-chip">{{ item.kind }}</div>
                    <div class="evidence-body">
                        <div class="camera-icon">📷</div>
                        <div>
                        <div class="evidence-title">{{ item.title }}</div>
                        <div class="evidence-subtitle">{{ item.subtitle }}</div>
                        </div>
                    </div>
                    </div>
                    <div class="evidence-footer">
                    <span>Annotated proof</span>
                    <span>linked to ticket</span>
                    </div>
                </div>
                }
            </div>
            </div>
        }

        </article>
    </section>
    </div>
</div>